export const removeMask = (mask: string) => {
    const regra = /[^a-z0-9]/gi;
    const value = mask.replace(regra, "");
    return value;
}

export const converterMoeda = (value: string | number) => {
    if(value === ''){
		return 0;
	}else{
        var val = String(value).trim();
        // Com vírgula é formato BR: ponto = milhar, vírgula = decimal ("1.500,50")
        if (val.includes(",")) return Number(val.replace(/\./g, "").replace(",", "."));
        // Sem vírgula, um único ponto seguido de 1 ou 2 dígitos é decimal ("150.50"); senão é milhar ("1.500")
        if (/^\d+\.\d{1,2}$/.test(val)) return Number(val);
        return Number(val.replace(/\./g, ""));
	}
}

export const displayMoney = (value: string | number) => {
    if(value || Number(value) === 0){
        const format = Intl.NumberFormat('pt-br', {
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2
        }).format(Number(value));
        return format;
    }else{
        return '';
    }
}

export function extrairNumeros(str: string) {
    // Usa uma expressão regular para encontrar todos os dígitos na string
    const numeros = str.match(/\d/g);

    // Se nenhum número for encontrado, retorna uma string vazia
    if (!numeros) {
        return "";
    }

    // Junta os números encontrados em uma única string e retorna
    return Number(numeros.join(""));
}